import * as Yup from 'yup'

const AddressSchema = Yup.object({
  address_line_1: Yup.string().required('INPUT.VALIDATION.AUTOLOCATION.ADDRESSLINE1'),
  country: Yup.string().required('INPUT.VALIDATION.AUTOLOCATION.COUNTRY'),
  address_line_2: Yup.string().nullable().optional(),
  city: Yup.string().nullable().optional(),
  state: Yup.string().nullable().optional(),
  postal: Yup.string().nullable().optional(),
  lat: Yup.number().nullable().optional(),
  lng: Yup.number().nullable().optional(),
})

export const RequirementAdvancedSchema = Yup.object({
  address: AddressSchema.required('INPUT.VALIDATION.REQUIREMENT.ADDRESS'),
  special_instructions: Yup.string().trim().nullable().optional(),
  documents_required: Yup.array()
    .of(Yup.string().trim().min(1, 'INPUT.VALIDATION.REQUIREMENT.DOCSREQ.ITEM'))
    .nullable()
    .optional(),
  documents_upload: Yup.array().nullable().optional(),
})

export type RequirementAdvancedSchemaType = Yup.InferType<typeof RequirementAdvancedSchema>

